import { directUser } from '@components/directUser';
import {
  alertModuleIsHidden,
  // beforeJump,
  checkCommentResolvedStatus,
  checkUserOnSamePage,
  isOnShownSource,
  urlMap,
} from '@components/directUser/data';
import actions from '@flux/action';
import store from '@flux/store';
import { getCommentData } from '@service/apis';
import alert from '@components/alert';
import commonActions from '@flux/action/common';
import { setSessionStorage } from '@utils/windowUtil';

export function getPathname(module, projectId) {
  const urlMap = {
    'Project Home': `/project-detail/${projectId}`,
    'Company Overview': '/analysis/companyoverview',
    Financials: '/analysis/financials',
    'Go-To-Market': '/analysis/gotomarket',
    ESG: '/analysis/esgAndCsr',
    'Operational Footprint': '/analysis/operationalfootprint',
    'Sentiment Analysis': '/analysis/sentimentanalysis',
    'Integration Approach': '/insights/integration-approach',
    'Separation Approach': '/insights/separation-approach',
    'Value Drivers': '/insights/value-driver',
    'Maturity Assessment': '/insights/maturityAssessment',
    'Integration Guiding Principles': '/insights/guidingPrinciples',
    'Divestiture Guiding Principles':
      '/insights/guidingPrinciples-divestitures',
    'Deal Rationale': '/insights/dealrationale',
  };
  return urlMap[module];
}

const isCustomizedModule = (module, component, identifier) =>
  module && identifier && !component;

const getCommentLatestStatus = async (commentId) => {
  if (!commentId) {
    throw new Error('missing arguments: commentId');
  }
  const { isDeleted, channelStatus } = (await getCommentData(commentId)) || {};
  return { isDeleted, channelStatus };
};

const goToProjectHome = (history, projectId) => {
  history.replace(`/project-detail/${projectId}`, {
    currentId: projectId,
  });
};

const handleCommentDeleted = (history, projectId) => {
  alert.warning({
    content: `The comment has been deleted.`,
  });
  goToProjectHome(history, projectId);
};

const handleResolvedComment = (hasPermission, targetInfo) => {
  if (!hasPermission) {
    return false;
  }
  return checkCommentResolvedStatus(targetInfo);
};

export async function handleLinkFromEmail(history) {
  try {
    const locationSearchParams = new URLSearchParams(history.location.search);
    if (locationSearchParams.get('fromEmail') !== 'true') {
      return;
    }
    const projectId = locationSearchParams.get('projectId');
    let module = locationSearchParams.get('module');
    const identifier = locationSearchParams.get('identifier');
    const component = locationSearchParams.get('component');
    const channel = Number(locationSearchParams.get('channel'));
    // let channelStatus = JSON.parse(locationSearchParams.get('channelStatus'));

    if (projectId && (module || identifier) && channel) {
      await store.dispatch(actions.getProjectInfo(projectId));
      store.dispatch(commonActions.changeLoading(true));
      await store.dispatch(actions.getCustomizedModules(projectId));
      store.dispatch(commonActions.changeLoading(true));
      // TODO module name my change due to new feature, better to use permission key to get correct module name
      if (isCustomizedModule(module, component, identifier)) {
        const customizedModules = store.getState()?.projects?.customizedModules;
        module =
          customizedModules.find((i) => i.value === identifier)?.module ||
          module;
      }

      const { channelStatus, isDeleted } = await getCommentLatestStatus(
        channel,
      );
      if (isDeleted) {
        return handleCommentDeleted(history, projectId);
      }

      const targetInfo = {
        projectId,
        moduleName: module,
        componentName: component === 'null' ? '' : component,
        identifier: identifier === 'null' ? '' : identifier,
        channel,
        channelStatus,
      };
      // const targetModule = urlMap[module];
      await store.dispatch(actions.getAccessibleModules(projectId));
      const accessibleModules =
        store.getState()?.projects?.accessibleModules || {};
      const hasPermission = await isOnShownSource(
        { module, identifier, component },
        accessibleModules,
      );
      const commentStatusValid = handleResolvedComment(
        hasPermission,
        targetInfo,
      );

      if (hasPermission && commentStatusValid) {
        setSessionStorage('currentId', projectId);
        await directUser(
          history,
          urlMap,
          targetInfo,
          () => true,
          checkUserOnSamePage,
        );
      } else {
        if (!hasPermission) {
          alertModuleIsHidden(component);
        }
        goToProjectHome(history, projectId);
      }
    }
    return;
  } catch (e) {
    console.log(e);
  }

  history.replace('projects/list');
}
